module.exports = __webpack_public_path__ + "static/media/sickle.2c74a75d.svg";